import { authApi } from "shared/api/authApi";

export const logoutRequest = () => {
  return authApi.logout();
};
